import ActionButton from './ActionButton'
import classNames from 'classnames'
import type {ComponentPropsWithClass} from '../helpers/react-helpers'

interface ToggleButtonProps extends ComponentPropsWithClass<typeof ActionButton> {
    checked: boolean
}

export default function ToggleButton({
                                         className,
                                         checked,
                                         ...props
                                     }: ToggleButtonProps) {

    return <ActionButton {...props}
                         className={classNames('toggle-button', className, checked ? 'toggle-button--checked' : 'toggle-button--unchecked')}/>
}
